import { combineReducers } from '@reduxjs/toolkit'
import { AuthenticationReducer } from '@meprism/shared/src/redux/authentication/authenticationSlice'
import { CorporateProfileReducer } from './CorporateProfile/CorporateProfileSlice'
import { CorporateBillingReducer } from './CorporateBilling/CorporateBillingSlice'

import { CorporateReducer } from './corporateService'

const appReducer = combineReducers({
  authentication: AuthenticationReducer,
  corporateProfile: CorporateProfileReducer,
  corporateService: CorporateReducer,
  corporateBilling: CorporateBillingReducer,
})

export const RootReducer: typeof appReducer = (state, action) => {
  if (action.type === 'USER_LOGOUT') {
    return appReducer(undefined, action)
  }

  return appReducer(state, action)
}
